import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Logo from './Logo';
import NavSearch from './NavSearch';
import { onMobileNavToggle, toggleCollapsedNav } from 'redux/actions/Theme';
import { SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import utils from 'utils';
import { ReduxState } from '../../redux/reducers';

const { Header } = Layout;

interface HeaderNavProps {
  navCollapsed: boolean;
  mobileNav: boolean;
  headerNavColor: string;
  onMobileNavToggle: (mobileNav: boolean) => void;
  toggleCollapsedNav: (navCollapsed: boolean) => void;
  isMobile: boolean;
  currentTheme: string;
  navProfile: React.ReactNode;
}

export const HeaderNav: React.FC<HeaderNavProps> = (props) => {
  const {
    navCollapsed,
    mobileNav,
    headerNavColor,
    onMobileNavToggle,
    toggleCollapsedNav,
    isMobile,
    currentTheme,
    navProfile,
  } = props;
  const [searchActive, setSearchActive] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (isMobile) {
      onMobileNavToggle(!mobileNav);
    } else {
      toggleCollapsedNav(!navCollapsed);
    }
  };

  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(currentTheme === 'dark' ? '#00000' : '#ffffff');
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isMobile || navCollapsed) {
      return '0px';
    }
    return `${SIDE_NAV_WIDTH}px`;
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  });

  return (
    <Header className={`app-header ${navMode}`} style={{ backgroundColor: headerNavColor }}>
      <div className={`app-header-wrapper `}>
        {!navCollapsed && <Logo logoType={navMode} />}
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              <li
                className="ant-menu-item ant-menu-item-only-child"
                onClick={() => {
                  onToggle();
                }}
              >
                {navCollapsed || isMobile ? (
                  <MenuUnfoldOutlined className="nav-icon" />
                ) : (
                  <MenuFoldOutlined className="nav-icon" />
                )}
              </li>
            </ul>
          </div>
          <div className="nav-right">
            <div className="mr-4">{navProfile}</div>
          </div>
          <NavSearch active={searchActive} close={onSearchClose} />
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }: ReduxState) => {
  const { navCollapsed, headerNavColor, mobileNav, currentTheme, direction } = theme;
  return { navCollapsed, headerNavColor, mobileNav, currentTheme, direction };
};

export default connect(mapStateToProps, { toggleCollapsedNav, onMobileNavToggle })(HeaderNav);
